<script setup lang="ts">
const siteUrl = useSiteUrl()

import { onMounted, ref } from 'vue'

const visible = ref(false)
const isShowSubmenus = ref(false)
const isShowPaymentSubmenus = ref(false)
const isShowGuideSubmenus = ref(false)

const telegramLinks = ['https://t.me/+989360950650', 'https://t.me/+989356049661']
const whatsappLinks = ['https://wa.me/989360950650', 'https://wa.me/989356049661']

const randomTelegramLink = ref('')
const randomWhatsappLink = ref('')

onMounted(() => {
  randomTelegramLink.value = telegramLinks[Math.floor(Math.random() * telegramLinks.length)]
  randomWhatsappLink.value = whatsappLinks[Math.floor(Math.random() * whatsappLinks.length)]
})
</script>

<template>
  <div class="card flex justify-center">
    <Drawer v-model:visible="visible" class="!bg-[#2626BF] text-white rounded-b-3xl" :show-close-icon="false"
      position="top" style="height: auto">
      <div class="flex items-center justify-between pb-6 mb-6 border-b">
        <nuxt-link to="/" class="mr-2 block lg:hidden">
          <img src="/home/img/home/logo-mobile.svg">
        </nuxt-link>

        <div class="cursor-pointer" @click="visible = false">
          <img src="/home/img/home/icon-close.svg">
        </div>
      </div>

      <div class="flex flex-col">
        <nuxt-link to="/" class="px-3 py-2 text-white">
          خانه
        </nuxt-link>

        <!-- خدمات پرداخت آنلاین -->
        <div class="w-full flex flex-col gap-3 py-2 px-3">
          <div class="cursor-pointer flex items-center gap-2.5 text-white font-normal text-sm"
            @click="isShowPaymentSubmenus = !isShowPaymentSubmenus">
            <span>خدمات پرداخت آنلاین</span>
            <img src="/home/img/home/arrow-square-down.svg" :class="isShowPaymentSubmenus ? 'rotate-180' : ''">
            <span
              class="-ms-1 h-5 flex items-center gap-0.5 rounded-full bg-gradient-to-r from-[#315CFF] via-[#4B8DFF] to-[#6A5CFF] px-2 py-0.5 text-[10px] font-bold text-white shadow-[0_0_10px_rgba(76,108,255,0.35)]">
              <!-- <span class="pt-0.5">✦</span> -->
              <span>جدید</span>
            </span>
          </div>

          <div v-if="isShowPaymentSubmenus"
            class="text-[#2626BF] bg-white rounded-xl shadow-lg px-4 p-3 mb-2 text-sm z-50 w-full">
            <a :href="siteUrl('/services/')" class="flex items-center gap-1 mb-4">
              خدمات پرداخت بین‌المللی
            </a>

            <a :href="siteUrl('/services/gift-cards')" class="flex items-center gap-1 mb-4">
              گیفت‌کارت
            </a>

            <a :href="siteUrl('/services/custom')" class="flex items-center gap-1">
              سفارش اختصاصی
            </a>
          </div>
        </div>

        <!-- خدمات انتقال آنلاین -->
        <a :href="siteUrl('/profile')" class="px-3 py-2 text-white">
          خدمات انتقال آنلاین
        </a>

        <!-- پشتیبانی -->
        <div class="w-full flex flex-col gap-3 py-2 px-3">
          <div class="cursor-pointer flex items-center gap-2.5 text-white font-normal text-sm"
            @click="isShowSubmenus = !isShowSubmenus">
            <span>پشتیبانی</span>
            <img src="/home/img/home/arrow-square-down.svg" :class="isShowSubmenus ? 'rotate-180' : ''">
          </div>

          <div v-if="isShowSubmenus"
            class="text-[#2626BF] bg-white rounded-xl shadow-lg px-4 p-3 mb-2 text-sm z-50 w-full">
            <a id="btn-telegram" :href="randomTelegramLink" class="flex items-center gap-1 mb-4">
              <img src="/home/img/telegram-2.svg" alt="telegram-icon">
              تلگرام
            </a>

            <a id="btn-whatsapp" :href="randomWhatsappLink" class="flex items-center gap-1">
              <img src="/home/img/whatsapp2.svg" alt="whatsapp-icon">
              واتساپ
            </a>
          </div>
        </div>

        <!-- راهنما -->
        <div class="w-full flex flex-col gap-3 py-2 px-3">
          <div class="cursor-pointer flex items-center gap-2.5 text-white font-normal text-sm"
            @click="isShowGuideSubmenus = !isShowGuideSubmenus">
            <span>راهنما</span>
            <img src="/home/img/home/arrow-square-down.svg" :class="isShowGuideSubmenus ? 'rotate-180' : ''">
          </div>

          <div v-if="isShowGuideSubmenus"
            class="text-[#2626BF] bg-white rounded-xl shadow-lg px-4 p-3 mb-2 text-sm z-50 w-full">
            <nuxt-link to="/terms" class="flex items-center gap-1 mb-4">
              قوانین پی‌جیب
            </nuxt-link>

            <nuxt-link to="/#questions" class="flex items-center gap-1 mb-4">
              سوالات متداول
            </nuxt-link>

            <nuxt-link to="/account-deletion" class="flex items-center gap-1">
              حذف حساب کاربری
            </nuxt-link>
          </div>
        </div>

        <!-- وبلاگ -->
        <a :href="siteUrl('/blog/')" class="px-3 py-2 text-white">
          وبلاگ
        </a>
        <NuxtLink to="/contact-us/" class="px-3 py-2 text-white">
          تماس با ما
        </NuxtLink>
        <NuxtLink to="/about/" class="px-3 py-2 text-white">
          درباره ما
        </NuxtLink>
      </div>
    </Drawer>

    <img src="/home/img/home/menu-burger-circle.svg" class="block lg:hidden" @click="visible = true">
  </div>
</template>